import React, { useState, useCallback, lazy, Suspense } from 'react';
import { Route, Switch, Redirect } from 'wouter';
import { useAuth } from './context/AuthContext';
import AppLayout from './components/AppLayout';
import Controle from './pages/Controle';
import Parametres from './pages/Parametres';
import Plantation from './pages/Plantation';
import Sonde from './pages/Sonde';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import RecoverPwd from './pages/RecoverPwd';
import { requestNotificationToken } from './firebase-messaging';
import { ref, set } from "firebase/database";
import { rtdb } from "./firebase";

const Landing = lazy(() => import('./pages/Landing'));

// Composant principal des routes
const AppRoutes = () => {
  const { loading, currentUser } = useAuth();
  
  if (loading) {
    return <div className="loading-large">Chargement...</div>;
  }
  
  return (
    <Switch>
      {/* Routes publiques (accessibles uniquement si non connecté) */}
      {!currentUser ? (
        <>
          <Route path="/" component={() => (
            <Suspense fallback={<div className="loading-large">Chargement...</div>}>
              <Landing />
            </Suspense>
          )} />
          <Route path="/signin" component={SignIn} />
          <Route path="/signup" component={SignUp} />
          <Route path="/recover-pwd" component={RecoverPwd} />
        </>
      ) : (
        /* Routes protégées (accessibles uniquement si connecté) */
        <AppLayout>
          <Switch>
            <Route path="/controle" component={Controle} />
            <Route path="/parametres" component={Parametres} />
            <Route path="/plantations" component={Plantation} />
            <Route path="/sondes" component={Sonde} />
            <Route path="/">
              <Redirect to="/plantations" />
            </Route>
          </Switch>
        </AppLayout>
      )}
    </Switch>
  );
};

// Composant principal de l'application
const App = () => {
  const [notifStatus, setNotifStatus] = useState(null);
  const { currentUser, selectedGreenhouse, hasPushToken, setPushTokenPresent } = useAuth();

  const handleEnableNotif = useCallback(async () => {
    try {
      const token = await requestNotificationToken();
      setNotifStatus('Notifications activées ! Token : ' + token);
      console.log('Token FCM :', token);

      if (currentUser && token) {
        await set(
          ref(rtdb, `pushTokens/${currentUser.uid}/${token}`),
          {
            greenhouseId: selectedGreenhouse,
            createdAt: new Date().toISOString(),
            userAgent: window.navigator.userAgent
          }
        );
        setPushTokenPresent(true);
        console.log("Token FCM enregistré dans RTDB :", token);
      }
    } catch (err) {
      setNotifStatus('Erreur : ' + err.message);
    }
  }, [currentUser, selectedGreenhouse, setPushTokenPresent]);

  return (
    <>
      <div className="notif-banner">
        {currentUser && !hasPushToken && (
          <>
            <button
              onClick={handleEnableNotif}
              className="btn-enable-notif"
            >
              Activer les notifications
            </button>
            {notifStatus && (
              <div className="notif-status-text">
                {notifStatus}
              </div>
            )}
          </>
        )}
      </div>
      <AppRoutes />
    </>
  );
};

export default App;
